/**
 * This function is used for "sleeping", pausing the execution of the current async function.
 *
 * @param {number} ms Duration of the pause in milliseconds.
 * @returns {*} A promise that sets a timeout based on the provided time.
 */
export function sleep(ms: number) {
  return new Promise((r) => setTimeout(r, ms));
}
